import type { RefObject } from 'react';
import { useCallback } from 'react';

import type { ApiJobId } from 'api/types/ApiTypedId';
import type { ScrollAreaHandle } from 'components/ScrollArea/ScrollArea';

type Args = {
  scrollingParentRef: RefObject<ScrollAreaHandle>;
};

export function useViewJobPageSidebarResultsScroll({
  scrollingParentRef,
}: Args) {
  const scrollToJobId = useCallback(
    (jobId: ApiJobId) => {
      const scrollingParent = scrollingParentRef.current?.viewportElement;
      if (!scrollingParent) return;

      const hitElement = scrollingParent.querySelector<HTMLElement>(
        `[data-hit-id="${jobId}"]`,
      );

      if (!hitElement) return;

      const isFirstChild =
        hitElement.parentNode?.firstElementChild === hitElement;

      /* When the user selects the first search hit, we want to show the "save search" button
       * This number doesn't have to be exact, it just needs to be big enough to reach the top of the scrolling container
       */
      const scrollMarginTop = isFirstChild ? 200 : 8;

      // Don't use hitElement.scrollIntoView() - it can cause the whole body to scroll
      scrollingParent.scrollTo(0, hitElement.offsetTop - scrollMarginTop);
    },
    [scrollingParentRef],
  );

  return { scrollToJobId };
}
